export default __webpack_public_path__ + "static/media/about.e7b3fb69.png";